import {
    createVNode as _$cv,
    className as _$cn,
} from 'intact';
import {getRestProps} from '../utils';
import {makeButtonGroupStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {className, vertical, children, fluid, seperate, separate} = this.get();
    const {k} = this.config;
    
    const classNameObj = {
        [`${k}-btns`]: true,
        [`${k}-vertical`]: vertical,
        [`${k}-fluid`]: fluid,
        [`${k}-separate`]: typeof separate === 'boolean' ? separate : separate,
        [className]: className,
        [makeButtonGroupStyles(k)]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, children);
};